import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import get from 'lodash/get';
import { HEADER_OFFSET } from '../../../constants';
import { BREAKPOINTS } from '../../../utils/commonHelper';
import { getTargeting } from './resources/adsConfig';
import adParams from './resources/adParams';
import { Ad } from '@dmm/react-common-components';
import AdProvider from '../../../components/Ads/AdProvider';
import BreadCrumb from '../../../components/BreadCrumb';
import ProductSchema from '../../../components/Schema/ProductSchema';
import Meta from '../../../components/Meta';
import { getBreadCrumb } from '../utils/breadcrumb';
import * as meta from '../utils/meta';
import NextPrevious from '../NextPrevious';
import Sticky from '../../../components/Sticky';
import * as listingHelper from '../../../utils/listingHelper';
import { getCurrency } from '../../../utils/uomHelper';
import { listingPropTypes } from '../../../utils/commonPropTypes';
import NextPreviousDataProvider from '../NextPreviousDataProvider';
import StickyContact from '../StickyContact';
import ImmersiveTourModal from '../../../components/ImmersiveTourModal';
import * as immersiveTourHelper from '../../../utils/immersiveTourHelper';
import SidePopUp from '../../../components/SidePopUP';
import SaveSearchFromDetails from '../../../components/SaveSearchFromDetails';
import './styles.css';
import { GetPreQualifiedModal } from '../../../components/GetPreQualified';
import BDPEmailLeadForm from '../BDPSections/BDPEmailLeadForm';
import BDPBoatSummary from '../BDPSections/BDPBoatSummary';
import classnames from 'classnames';
import { useFeatureFlags } from '../../../context/hooks/useFeatureFlags';

import { calculateMonthlyPrice } from '../../../utils/trident';

import { useBdp } from './bdpController/bdpManager';
import { getSecondAdParams } from './bdpController/bdpHelpers';
import BDPCarouselModal from '../BDPSections/BDPCarouselModal';
import BDPEmailLeadFormModal from '../BDPSections/BDPEmailLeadFormModal';

const AdditionalLeadsModal = loadable(() =>
  import('../../../components/AdditionalLeadsModal')
);
const LiveVideoTourModal = loadable(() =>
  import('../../../components/LiveVideoTourModal')
);

const BrokerDealerBDP = (props) => {
  const { state, setState, bdp } = useBdp(props);
  const { bdpContext, handlers, selectors, actions, carouselButtons } = bdp;
  const { additionalLeadsModalOpen, isLeadSubmitted } = selectors;
  const { setGenericEventAction, createSearchAlertAction } = actions;
  const {
    uom,
    seoConfig,
    customMeta,
    showThirdAdbox,
    portal,
    showBottomAdBox,
    supportsSavedSearchOnBDP,
    DetailsSectionVariant,
    pageAdsConfig,
    customUom,
    showManufacturerForm,
    supportsTridentCalculator
  } = bdpContext;
  const {
    hideModal,
    handleOpenContactModal,
    handleCloseContactModal,
    handleBoatSummaryScroll,
    toggleVideoTourModal,
    showModalPreQualified,
    handleOpenContactForm,
    openImmersiveTourModal,
    openModalPostLead,
    openCarousel,
    previousNextHandler
  } = handlers;

  const {
    listing,
    isWorking,
    carouselClickCount,
    ficoScores,
    tridentTeaserRate,
    tridentLoanAmount,
    tridentTermInMonths,
    navLinks
  } = props;

  const { featureFlagBDPNewDesign } = useFeatureFlags();

  const targeting = getTargeting(
    listing,
    customUom && customUom.length ? customUom.length.abbr : uom
  );
  const breadCrumbItems = getBreadCrumb(listing, state.breakpoint);
  const numCarouselClickToReloadPageAds = 3;
  const numCarouselClickToReloadModalAds = 5;
  const pageAdReload = Math.floor(carouselClickCount / numCarouselClickToReloadPageAds) || 0;
  const modalAdReload = Math.floor(carouselClickCount / numCarouselClickToReloadModalAds) || 0;
  const secondAdBoxParams = getSecondAdParams(
    showThirdAdbox,
    pageAdReload,
    adParams
  );

  const monthlyPrice = calculateMonthlyPrice(
    tridentTeaserRate,
    tridentTermInMonths,
    tridentLoanAmount
  );

  const { next, previous} = navLinks;
  const isDesktop = state.breakpoint === BREAKPOINTS.desktop;
  const hidden = !previous && !next && !isDesktop;

  return (
    <>
      <ImmersiveTourModal
        isOpen={state.showImmersiveTourModal}
        closeModal={() => setState({ ...state, showImmersiveTourModal: false })}
        title={immersiveTourHelper.getTitle(listing)}
        url={get(listing, 'virtualTour.url')}
      />
      <AdProvider
        url={get(props, 'location.pathname', '')}
        isWorking={props.isWorking}
        targeting={targeting}
        adsConfig={pageAdsConfig}
      >
        <Meta
          noindex={meta.getNoIndex()}
          canonical={meta.getCanonical(listing)}
          next={meta.getLinkRelNext()}
          prev={meta.getLinkRelPrev()}
          title={meta.getMetaTitle(listing, portal, seoConfig, customUom)}
          description={meta.getMetaDescription(listing, portal, customMeta)}
        />
        <ProductSchema
          listing={listing}
          labels={{
            getTitle: listingHelper.getTitle,
            getCurrency: getCurrency
          }}
        />
        <NextPreviousDataProvider {...props} />

        {/* Saved search popup */}
        {supportsSavedSearchOnBDP && (
          <SidePopUp
            listingId={listing.id}
            hideSavedSearchPopup={state.hideSavedSearchPopup}
            tracking={{ setGenericEvent: setGenericEventAction }}
            portal={portal}
          >
            <SaveSearchFromDetails
              idPrefix="modal-save-search-section"
              data={listingHelper.getSavedSearchDetailsData(listing)}
              searchPath={listingHelper.getSavedSearchDetailsSearchPath(
                listing
              )}
              createSearchAlert={createSearchAlertAction}
              tracking={{
                setGenericEvent: setGenericEventAction,
                submitEvent: 'SaveSearchPopupSubscribed'
              }}
              listingId={listing.id}
              portal={portal}
            />
          </SidePopUp>
        )}

        <div className="boat-details bdp-broker-dealer">
          <BDPEmailLeadFormModal
            show={state.showContactModal}
            onClose={handleCloseContactModal}
            listing={listing}
            portal={portal}
            onSuccess={openModalPostLead}
          />

          <div id="root-anchor"></div>
          {featureFlagBDPNewDesign && (
            state.breakpoint === 'desktop' ? (
              <div className="bdp-top-ad">
                <Ad
                  {...adParams.leaderboardBDPTopParams}
                  reloadAd={pageAdReload}
                  targeting={{ refresh: pageAdReload.toString() }}
                />
              </div>
            ) : (
              <div className="bdp-top-ad">
                <Ad
                  {...adParams.mobileBDPLeaderboardParams}
                  reloadAd={pageAdReload}
                  targeting={{ refresh: pageAdReload.toString() }}
                />
              </div>
            )
          )}
          <div className={classnames('nextPrevBDP', { 'scroll': state.scrolledPastBoatSummary, hidden })}>
            <NextPrevious
              listing={listing}
              breadCrumbs={breadCrumbItems}
              navLinks={props.navLinks}
              isLoading={isWorking}
              breakpoint={state.breakpoint}
              showInfo={state.scrolledPastBoatSummary}
              tracking={{ setGenericEvent: setGenericEventAction }}
              longNextPrevious={true}
            />
          </div>
          <div className="top broker-bdp">
            <div className="broker-bdp-left">
              <BDPCarouselModal
                breakpoint={state.breakpoint}
                isLoading={isWorking}
                show={state.showModalCarousel}
                carouselIndex={state.carouselIndex}
                hideModal={hideModal}
                carouselAddParams={adParams}
                carouselButtons={carouselButtons}
                handleOpenContactForm={handleOpenContactForm}
                openImmersiveTourModal={openImmersiveTourModal}
                handleCarouselItemClick={(e, index) => openCarousel(index)}
                previousNextHandler={previousNextHandler}
                adReload={modalAdReload}
              />
              {!featureFlagBDPNewDesign && (
               state.showLeaderboardDesktopAds ? (
                <div className="bdp-ad">
                  <Ad
                    {...adParams.leaderboardTopParams}
                    reloadAd={pageAdReload}
                    targeting={{ refresh: pageAdReload.toString() }}
                  />
                </div>
              ) : (
                <div className="bdp-ad">
                  <Ad
                    {...adParams.mobileLeaderboardParams}
                    reloadAd={pageAdReload}
                    targeting={{ refresh: pageAdReload.toString() }}
                  />
                </div>
              )
              )}
              {state.breakpoint !== BREAKPOINTS.desktop && (
                <>
                  <BreadCrumb items={breadCrumbItems} />
                  <BDPBoatSummary
                    listing={listing}
                    monthlyPrice={monthlyPrice}
                    supportsTridentCalculator={supportsTridentCalculator}
                    customUom={customUom ? customUom.length : undefined}
                  />
                </>
              )}

              <div className="content">
                <Sticky
                  position="top"
                  offset={HEADER_OFFSET}
                  onChange={handleBoatSummaryScroll}
                />
                <DetailsSectionVariant
                  isLoading={isWorking}
                  listing={listing}
                  openPaymentSection={state.openPaymentComponent}
                  openPaymentCounter={state.openPaymentComponentCounter}
                  openLocationSection={state.openLocationComponent}
                  openLocationCounter={state.openLocationComponentCounter}
                  openBoatLoansSection={state.openBoatLoansComponent}
                  openBoatLoansCounter={state.openBoatLoansComponentCounter}
                  breakpoint={state.breakpoint}
                  onOpenContactForm={handleOpenContactModal}
                  adParams={adParams}
                  showManufacturerForm={showManufacturerForm}
                  customUom={customUom}
                  hideSavedSearchPopup={state.showContactModal}
                  setGenericEvent={setGenericEventAction}
                  pageType={props.pageType}
                  boatLoansSection={props.boatLoansSection}
                  tridentTermInMonths={tridentTermInMonths}
                  tridentLoanAmount={tridentLoanAmount}
                  tridentTeaserRate={tridentTeaserRate}
                  showModalPreQualified={showModalPreQualified}
                  isLeadSubmitted={isLeadSubmitted}
                />
                {showBottomAdBox &&
                  (state.showLeaderboardDesktopAds ? (
                    <div className="bdp-ad">
                      <Ad {...adParams.leaderboardBottomParams} />
                    </div>
                  ) : (
                    <div className="bdp-ad">
                      <Ad {...adParams.mobileBox2Params} />
                    </div>
                  ))}
              </div>
            </div>
            <div className="top-right broker-bdp-right">
              {state.breakpoint === BREAKPOINTS.desktop && (
                <BDPBoatSummary
                  listing={listing}
                  monthlyPrice={monthlyPrice}
                  supportsTridentCalculator={supportsTridentCalculator}
                  customUom={customUom ? customUom.length : undefined}
                />
              )}

              {!showManufacturerForm &&
                state.breakpoint === BREAKPOINTS.desktop &&
                !state.showModalCarousel && (
                  <BDPEmailLeadForm
                    listing={listing}
                    portal={portal}
                    onSuccess={openModalPostLead}
                  />
                )}

              {state.breakpoint === 'desktop' && (
                <div className="right-ad">
                  <div className="sticky-ads">
                    <div className="add-tmp">
                      <Ad
                        {...adParams.sideBarAd1Params}
                        reloadAd={pageAdReload}
                        targeting={{ refresh: pageAdReload.toString() }}
                      />
                    </div>
                    <div className="add-tmp">
                      <Ad {...secondAdBoxParams} />
                    </div>
                    {showThirdAdbox && (
                      <div className="add-tmp">
                        <Ad {...adParams.sideBarAd3Params} />
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
          {state.breakpoint === 'mobile' && (
            <Ad {...adParams.mobileBox2Params} />
          )}
        </div>
        {(state.breakpoint === BREAKPOINTS.mobile ||
          (state.breakpoint === BREAKPOINTS.tablet &&
            !state.showModalCarousel)) && (
          <StickyContact
            isManufacturer={false}
            isLoading={isWorking}
            listing={listing}
            onOpenContact={handleOpenContactModal}
          />
        )}
        {additionalLeadsModalOpen && <AdditionalLeadsModal />}
        {state.showVideoTourForm && (
          <LiveVideoTourModal
            listingId={listing.id}
            onClose={toggleVideoTourModal}
          />
        )}

        {state.showModalPreQualified && (
          <GetPreQualifiedModal
            onClose={() => showModalPreQualified(false)}
            isMobile={state.breakpoint === 'mobile'}
            interestRate={tridentTeaserRate}
            monthlyPrice={monthlyPrice}
            listing={listing}
            ficoScores={ficoScores}
            leadPage="BDP"
          />
        )}
      </AdProvider>
    </>
  );
};

BrokerDealerBDP.defaultProps = {
  navLinks: {},
};

BrokerDealerBDP.propTypes = {
  isWorking: PropTypes.bool,
  listing: listingPropTypes,
  location: PropTypes.shape({
    pathname: PropTypes.string
  }),
  navLinks: PropTypes.shape({
    next: PropTypes.string,
    previous: PropTypes.string
  }),
  carouselClickCount: PropTypes.number,
  pageType: PropTypes.string,
  boatLoansSection: PropTypes.object,
  ficoScores: PropTypes.array,
  tridentTeaserRate: PropTypes.number,
  tridentLoanAmount: PropTypes.number,
  tridentTermInMonths: PropTypes.number
};

export default BrokerDealerBDP;
